import React from "react";

const WhiteTrashIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
        fill="white"
      />
    </svg>
  );
};

const FileUploadField = ({ limitMegabyteSize, uploadedFile, onRemove }) => {
  const getImageUrl = (file) => {
    if (!file) return null;
    if (typeof file === "string") return file;
    if (file.url) return file.url;
    if (file.thumbUrl) return file.thumbUrl;
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
    return null;
  };

  const imageUrl = getImageUrl(uploadedFile);

  return (
    <div
      className="uploadBox upload-dashed-border-image dragEffect"
      style={{ position: "relative" }}
    >
      {imageUrl ? (
        <>
          <img
            src={imageUrl}
            alt="Cover"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              position: "absolute",
              top: 0,
              left: 0,
              borderRadius: "inherit",
            }}
          />
          {onRemove && (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onRemove();
              }}
              style={{
                position: "absolute",
                top: "8px",
                right: "8px",
                background: "rgba(0, 0, 0, 0.7)",
                border: "none",
                cursor: "pointer",
                padding: "6px",
                zIndex: 1,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "28px",
                height: "28px",
              }}
            >
              <WhiteTrashIcon />
            </button>
          )}
        </>
      ) : (
        <>
          <p className="notifymessage">
            Drop your cover photo here or <span>Browse</span>
          </p>
          <p className="fileFormat">{`PNG, JPG, or GIF Up to ${limitMegabyteSize}MB.`}</p>
        </>
      )}
    </div>
  );
};

export default FileUploadField;
